/* Golden Month free candle (Nov 2026).
   A free small candle for orders of $100+, a large one (instead) at $125+, for Melbourne Metro deliveries and pickup only.
   - Qualifying total: cart.total_price (after discounts; delivery is a shipping rate, not a line) minus the candle lines
     and the Just Right order-protection line (same subtotal the drawer and cart page show).
   - Place: the cart attributes Checkout-Method / Delivery-Postcode the Pickup & Delivery widget writes when a choice is
     saved; before that, the place in sessionStorage "pd:draft" (delivery bar / an earlier saved choice). Metro = a delivery postcode on
     the app's Melbourne list and not on its Greater Melbourne list (GET /apps/pickup-delivery/config), as the widget
     classifies it. Pickup counts. Rest of Australia, Greater Melbourne and Express (economy) don't.
   - Before a place is chosen: the bar shows, but no candle is added (one already in the cart stays and follows the total).
   - One candle line at most, quantity 1. Added / swapped / removed here with /cart/add.js and /cart/change.js by line key.
     Writes wait for the cart to be quiet (other scripts' writes debounce the check) and never run while the delivery
     widget is saving. At most 6 writes in 20 s, so it can't loop.
   - Runs on the cart page and while the drawer is open (nothing on other pages until the drawer opens).
   - The drawer (gl-cro.js) and the cart page (gl-v3-cart.js) draw the card and the candle line with GLCD.card / GLCD.line. */
(function () {
  'use strict';
  var CF = window.GLCD_CFG || {};
  if (!CF.small || !CF.large) return;
  var SMALL = +CF.small, LARGE = +CF.large, MIN = 10000, MAX = 12500;
  var VAL = { s: 3000, l: 4900 };
  var oFetch = window.fetch.bind(window);
  var isCart = /^\/cart\/?$/.test(location.pathname);
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (c) { c = Math.max(0, Math.round(c)); return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); };
  var ss = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { v == null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  var isCandle = function (i) { return i && (i.variant_id === SMALL || i.variant_id === LARGE); };
  var isGuarantee = function (i) { return /Delivery Guarantee/i.test(i.product_type || '') || i.handle === 'just-right-delivery'; };
  var qual = function (cart) {
    return ((cart && cart.items) || []).reduce(function (t, i) { return t - (isCandle(i) || isGuarantee(i) ? i.final_line_price : 0); }, (cart && cart.total_price) || 0);
  };

  /* ---- delivery config (postcode lists), cached for 30 min ---- */
  var cfgP = null;
  function cfg() {
    var c = ss.get('glcd:cfg');
    if (c && Date.now() - c.t < 18e5) return Promise.resolve(c);
    return cfgP || (cfgP = oFetch('/apps/pickup-delivery/config', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var o = { t: Date.now(), melb: String(j.melbournePostcodes || ''), greater: String((j.windows && j.windows.greater && j.windows.greater.postcodes) || '') };
        if (!o.melb) throw new Error('no postcodes');
        ss.set('glcd:cfg', o); return o;
      }).catch(function () { cfgP = null; return null; }));
  }
  // same rule parser as the app (app/lib/postcodes.ts)
  var inRules = function (pc, text) {
    var n = parseInt(pc, 10);
    return String(text || '').split(/[\s,;]+/).some(function (t) {
      var m = t.match(/^(\d{3,4})\s*[-–:]\s*(\d{3,4})$/);
      return m ? n >= Math.min(+m[1], +m[2]) && n <= Math.max(+m[1], +m[2]) : /^\d{3,4}$/.test(t) && +t === n;
    });
  };

  /* ---- stock, cached for 5 min ---- */
  var avP = null;
  function stock() {
    var c = ss.get('glcd:av');
    if (c && Date.now() - c.t < 3e5) return Promise.resolve(c);
    var one = function (h, v) {
      return oFetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        var x = p && (p.variants || []).filter(function (y) { return y.id === v; })[0];
        return x ? { ok: !!x.available, img: p.featured_image || '' } : { ok: false, img: '' };
      });
    };
    return avP || (avP = Promise.all([one(CF.sh || 'free-small-candle', SMALL), one(CF.lh || 'free-large-candle', LARGE)])
      .then(function (a) { var o = { t: Date.now(), s: a[0].ok, l: a[1].ok, si: a[0].img, li: a[1].img }; ss.set('glcd:av', o); avP = null; return o; })
      .catch(function () { avP = null; return null; }));
  }
  var AV = ss.get('glcd:av'), CFG = ss.get('glcd:cfg');

  /* ---- place: "ok" (Metro delivery or pickup), "no" (anything else chosen), "" (nothing chosen yet) ---- */
  function place(cart) {
    // the saved choice (cart attributes, written when the widget saves) first; else the place the delivery bar / widget
    // keeps in pd:draft (it is written as a choice is saved, so it can lag behind the widget on screen)
    var d = ss.get('pd:draft'), a = (cart && cart.attributes) || {}, m = '', pc = '', eco = false;
    if (a['Checkout-Method']) {
      var cm = String(a['Checkout-Method']).toLowerCase();
      m = /pick/.test(cm) ? 'pickup' : 'delivery';
      pc = a['Delivery-Postcode'] || '';
      eco = cm === 'shipping';
    } else if (d && d.method) { m = d.method; pc = d.postcode || ''; eco = !!d.economy; }
    if (m === 'pickup') return 'ok';
    if (m !== 'delivery') return '';
    pc = String(pc).replace(/\D/g, '');
    if (pc.length < 3) return '';
    if (eco) return 'no';
    if (!CFG) return '';
    return inRules(pc, CFG.melb) && !inRules(pc, CFG.greater) ? 'ok' : 'no';
  }
  var placeKey = function () { var d = ss.get('pd:draft') || {}; return [d.method || '', d.postcode || '', d.economy ? 1 : 0, d.date || ''].join('|'); };

  /* ---- what the cart should hold ---- */
  function want(cart) {
    var q = qual(cart), st = place(cart), have = cart.items.filter(isCandle);
    if (!AV || !AV.s) return { target: 0, hide: true, st: st, q: q };
    var big = AV.l, tier = q >= MAX && big ? LARGE : q >= MIN ? SMALL : 0;
    var target = st === 'ok' ? tier : st === 'no' ? 0 : have.length ? tier : 0;
    // nothing real in the cart: never a candle on its own
    if (!cart.items.some(function (i) { return !isCandle(i) && !isGuarantee(i); })) target = 0;
    return { target: target, st: st, q: q, big: big, tier: tier };
  }
  var matches = function (cart, w) {
    var have = cart.items.filter(isCandle);
    return w.target ? have.length === 1 && have[0].variant_id === w.target && have[0].quantity === 1 : !have.length;
  };

  /* ---- writes ---- */
  var post = function (u, b) {
    return oFetch(u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) })
      .then(function (r) { if (!r.ok) throw new Error(u + ' ' + r.status); return r.json(); });
  };
  var getCart = function () { return oFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
  var writes = [], stopped = false;
  function apply(cart, w) {
    var have = cart.items.filter(isCandle), ops = [];
    have.forEach(function (i, n) {
      if (w.target && i.variant_id === w.target && !ops.keep) { ops.keep = 1; i.quantity !== 1 && ops.push(['change', { id: i.key, quantity: 1 }]); }
      else ops.push(['change', { id: i.key, quantity: 0 }]);
    });
    if (w.target && !ops.keep) {
      // carry the delivery widget's hidden line id, as it puts it on every line it saves
      var src = cart.items.filter(function (i) { return !isCandle(i) && (i.properties || {})._ZapietId; })[0], props = { _gl_src: 'free-candle' };
      src && (props._ZapietId = src.properties._ZapietId, src.properties['_Delivery-Window'] && (props['_Delivery-Window'] = src.properties['_Delivery-Window']));
      ops.push(['add', { items: [{ id: w.target, quantity: 1, properties: props }] }]);
    }
    if (!ops.length) return Promise.resolve(null);
    var now = Date.now();
    writes = writes.filter(function (t) { return now - t < 2e4; });
    if (writes.length + ops.length > 6) { stopped = true; console.warn('[gl-candle] too many cart writes, stopped'); return Promise.resolve(null); }
    var removedOut = w.st === 'no' && have.length;
    return ops.reduce(function (p, o) {
      return p.then(function () { writes.push(Date.now()); return post(o[0] === 'add' ? '/cart/add.js' : '/cart/change.js', o[1]); });
    }, Promise.resolve()).catch(function (e) { console.warn('[gl-candle]', e && e.message); })
      .then(function () { removedOut ? ss.set('glcd:removed', 1) : w.target && ss.set('glcd:removed', null); return getCart(); });
  }

  /* ---- the check: debounced, one at a time ---- */
  var T = 0, running = false, again = false, waits = 0;
  function active() { return isCart || !!document.querySelector('.glc-drawer--open'); }
  function schedule(ms) {
    if (stopped) return;
    clearTimeout(T);
    T = setTimeout(run, ms == null ? 900 : ms);
  }
  function run() {
    if (!active()) return;
    if (running) { again = true; return; }
    var api = window.PickupDelivery && window.PickupDelivery.api, s = api && api.getState && api.getState();
    if (s && s.saving && waits++ < 20) return schedule(800);
    waits = 0; running = true;
    Promise.all([getCart(), cfg(), stock()]).then(function (x) {
      CFG = x[1] || CFG; AV = x[2] || AV;
      var cart = x[0];
      // stock unknown (request failed): change nothing
      if (!AV) return;
      var w = want(cart);
      // "We've removed it" only while a non-Metro place stays chosen
      w.st !== 'no' && ss.set('glcd:removed', null);
      if (matches(cart, w)) return paint(cart);
      return apply(cart, w).then(function (c) { c && paint(c); });
    }).catch(function (e) { console.warn('[gl-candle]', e && e.message); })
      .then(function () { running = false; if (again) { again = false; schedule(300); } });
  }
  // redraw the surfaces that show the card (they redraw themselves from this cart)
  var lastSig = '';
  function paint(cart) {
    var sig = JSON.stringify([cart.token, cart.item_count, cart.total_price, cart.items.map(function (i) { return i.key + i.quantity; }), place(cart), !!ss.get('glcd:removed'), AV && [AV.s, AV.l]]);
    if (sig === lastSig) return;
    lastSig = sig;
    try { window.GLA && GLA.badge && GLA.badge(cart); } catch (e) {}
    try { window.GLCRO_DR && GLCRO_DR.render(cart); } catch (e) { console.warn('[gl-candle] drawer', e); }
    try { window.GL3C && GL3C.render(cart); } catch (e) { console.warn('[gl-candle] cart', e); }
  }

  /* ---- what the drawer / cart page draw ---- */
  function bar(q, big, img) {
    var top = big ? MAX : MIN, pct = function (v) { return Math.min(100, (v / top) * 100); }, h1 = q >= MIN, h2 = big && q >= MAX;
    var mark = function (left, cls, src, alt) { return '<div class="glcd-m ' + cls + '" style="left:' + left + '%"><div class="glcd-dot">' + (src ? '<img src="' + esc(src) + '" alt="' + alt + '" width="34" height="34">' : '') + '</div></div>'; };
    return '<div class="glcd-track" aria-hidden="true"><div class="glcd-fill" style="width:' + pct(q) + '%"></div>' +
      mark(pct(MIN), h1 && !h2 ? 'hit' : h2 ? 'past' : '', img.s, '') + (big ? mark(100, h2 ? 'hit' : '', img.l, '') : '') + '</div>' +
      '<div class="glcd-lbls" aria-hidden="true"><span>' + money(q) + ' in cart</span><span class="' + (h1 && !h2 ? 'hit' : '') + '" style="left:' + pct(MIN) + '%">' + money(MIN) + '</span>' + (big ? '<span class="' + (h2 ? 'hit' : '') + '" style="left:100%">' + money(MAX) + '</span>' : '') + '</div>';
  }
  var FINE = 'Free candle only applies to Melbourne Metro deliveries and pickup. While&nbsp;stocks&nbsp;last.';
  function card(cart, surface) {
    if (!cart || !cart.items || !AV || !AV.s) return '';
    if (!cart.items.some(function (i) { return !isCandle(i) && !isGuarantee(i); })) return '';
    var w = want(cart), q = w.q, big = w.big, have = cart.items.filter(isCandle)[0], img = { s: AV.si && AV.si + (AV.si.indexOf('?') > -1 ? '&' : '?') + 'width=120', l: AV.li && AV.li + (AV.li.indexOf('?') > -1 ? '&' : '?') + 'width=120' };
    var deal = '';
    if (surface === 'drawer' && window.GLA && GLA.deal) {
      var d = GLA.deal(cart);
      d.html && (deal = '<div class="glcd-add' + (d.ok ? ' ok' : '') + '"><i aria-hidden="true">' + (d.ok ? '&#10003;' : '+') + '</i><span>' + d.html + '</span></div>');
    }
    var inner;
    if (w.st === 'no') {
      inner = '<div class="glcd-offrow"><div class="glcd-dot">' + (img.s ? '<img src="' + esc(img.s) + '" alt="" width="40" height="40">' : '') + '</div><p>Free candle only applies to Melbourne Metro deliveries and pickup.' +
        (ss.get('glcd:removed') || have ? '<span>We\'ve removed it from your&nbsp;cart.</span>' : '') + '</p></div>';
      return '<div class="glcd glcd--off" data-glcd>' + inner + deal + '</div>';
    }
    var added = have && w.target, l = added ? have.variant_id === LARGE : q >= MAX && big, msg;
    if (q < MIN) msg = '<p class="glcd-t">Spend <b>' + money(MIN - q) + '</b> more for a free candle (valued ' + money(VAL.s) + ')</p>';
    else {
      var name = l ? 'large' : 'small';
      msg = '<p class="glcd-t ok"><b>' + (added ? 'Free ' + name + ' candle added' : 'Free ' + name + ' candle unlocked') + ' &#127881;</b>' +
        (!l && big ? '<span class="glcd-next">Spend <b>' + money(MAX - q) + '</b> more for the large one (valued ' + money(VAL.l) + ')</span>' : '') + '</p>';
    }
    var fine = q >= MIN && !added ? 'We\'ll add it when you choose Melbourne Metro delivery or pickup. While&nbsp;stocks&nbsp;last.' : FINE;
    return '<div class="glcd" data-glcd role="status"><div class="glcd-gift">' + msg + bar(q, big, img) + '<p class="glcd-fine">' + fine + '</p></div>' + deal + '</div>';
  }
  // the candle's own line: was / $0, a "Free gift" tag, no quantity or Remove (it follows the rules above)
  function line(i, surface) {
    var l = i.variant_id === LARGE, img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
    var was = (i.original_price && i.original_price > 0 ? i.original_price : 0) || (l ? VAL.l : VAL.s);
    var price = '<b class="glcd-price"><s>' + money(was) + '</s>' + money(i.final_line_price) + '</b>';
    var sub = '<span class="glcd-tag">Free gift</span><span class="glcd-sub">Soy candle &middot; added for orders over ' + money(l ? MAX : MIN) + '</span>';
    if (surface === 'drawer')
      return '<div class="glc-line glcd-line" data-glcd-line><div class="glc-line__img glcd-im">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="glc-line__info"><div class="glc-line__top"><span class="glc-line__title">' + esc(i.product_title) + '</span>' + price + '</div>' + sub + '</div></div>';
    return '<div class="g3c-item glcd-line" data-glcd-line><div class="g3c-im glcd-im">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</div><div class="g3c-it"><div class="g3c-it1"><b>' + esc(i.product_title) + '</b>' + price + '</div>' + sub + '</div></div>';
  }
  // candles last in a list of lines (Shopify puts the newest line first)
  var last = function (items) { return items.filter(function (i) { return !isCandle(i); }).concat(items.filter(isCandle)); };

  window.GLCD = {
    is: isCandle,
    card: function (cart, surface) {
      var h = '';
      try { h = card(cart, surface); } catch (e) { console.warn('[gl-candle] card', e); }
      // a cart that doesn't match the rules yet (drawer just opened, someone else's write): check it
      try { cart && cart.items && (!AV || !CFG || !matches(cart, want(cart))) && !running && schedule(400); } catch (e) {}
      return h;
    },
    line: line,
    last: last,
    check: function () { schedule(200); }
  };

  /* ---- triggers ---- */
  // any other script's cart write (fetch or XHR): check once the cart has been quiet for 0.9 s
  var CW = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var bump = function () { active() && schedule(900); };
  try {
    var wf = window.fetch;
    window.fetch = function (u) {
      var r = wf.apply(this, arguments);
      try { CW.test(String((u && u.url) || u)) && r.then(bump, bump); } catch (e) {}
      return r;
    };
    var oO = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { CW.test(String(u)) && this.addEventListener('loadend', bump); } catch (e) {}
      return oO.apply(this, arguments);
    };
  } catch (e) {}
  window.addEventListener('pickup-delivery:state', function () { active() && schedule(300); });
  // the widget's draft changes as a postcode is typed (no event): sessionStorage only, no requests
  var pk = placeKey();
  setInterval(function () { var k = placeKey(); if (k !== pk) { pk = k; active() && schedule(400); } }, 1000);
  var boot = function () { isCart && schedule(300); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
